'use strict';

var MarketProductGroupDateRangeLevelChartFilterFactory = function MarketProductGroupDateRangeLevelChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupMarketFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupClassGroupFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function MarketProductGroupDateRangeLevelChartFilter() {
    DemandFilter.call(this, 'market-product-group', 'date-range-level-chart');
    this.registerFilters(injectedFilters);
  }
  MarketProductGroupDateRangeLevelChartFilter.constructor = MarketProductGroupDateRangeLevelChartFilter;
  MarketProductGroupDateRangeLevelChartFilter.prototype = Object.create(DemandFilter.prototype);
  return MarketProductGroupDateRangeLevelChartFilter;
};
MarketProductGroupDateRangeLevelChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketProductGroupDateRangeLevelChartFilterFactory;